import { ErrorResponse } from '../types/ErrorResponseTypes'
import { DataResponse } from '../types/ApiResponseTypes'
import { AxiosResponse } from 'axios'
import router from '../router'
import { eventBus } from './eventBusService'

class ApiService {
  parseResponse(response: AxiosResponse | undefined): ErrorResponse | DataResponse {
    //  GLOBAL NETWORK GUARD
    // response is undefined, the request failed before reaching the server
    if (!response) {
      if (!navigator.onLine) {
        console.debug('offline')
        eventBus.emit('networkError', 'offline')
      } else {
        eventBus.emit('networkError', 'server-unreachable')
      }
      throw new Error('Network Error')
    }

    // FORBIDDEN GUARD
    if (response.status === 403) {
      router.push({ name: 'Forbidden' })
      throw new Error('Forbidden')
    }

    // NORMAL HANDLING
    if (response.status >= 200 && response.status <= 299) {
      return this.extract(response)
    } else if (response.status >= 400 && response.status <= 500) {
      return this.extract(response)
    } else {
      console.debug('else')
      throw new Error("Status Code can't be handled")
    }
  }

  extract(response: AxiosResponse): DataResponse {
    return response.data
  }
}

export default ApiService
